import {Routes, UrlMatchResult, UrlSegment} from '@angular/router';
import {languageGuard} from "../shared/guards/language.guard";
import {customerUserGuard} from "../shared/guards/customer-user.guard";
import {passwordChangeEnforcementGuard} from "../shared/guards/password-change-enforcement.guard";

const newsListMatcher = (segments: UrlSegment[]): UrlMatchResult | null => {
  if (segments.length === 0 || segments[0].path !== 'list') {
    return null;
  }
  if (segments.length === 1) {
    return {consumed: segments};
  }
  if (segments.length === 2) {
    return {
      consumed: segments,
      posParams: {id: segments[1]}
    };
  }
  return null;
};

export const newsRoutes: Routes = [
  {path: "", redirectTo: "list", pathMatch: "full"},
  {
    matcher: newsListMatcher,
    loadComponent: () => import('../modules/news/news-list/news-list.component').then((c) => c.NewsListComponent),
    canActivate: [languageGuard, customerUserGuard, passwordChangeEnforcementGuard],
    data: {preload: 'base'}
  },
];
